<template>
  <div class="rank-filter">
    <div class="rank-title">
      {{ title }}
    </div>
    <div v-if="showFilter" class="filter-top">
      <el-select style="width: 230px" v-model="current" placeholder="请选择" size="mini" @change="getChannel">
        <el-option label="所有" value="all" v-if="!(type === 'online' || type === 'code')"></el-option>
        <el-option
          v-for="(item, index) in options"
          :key="index"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
    </div>
    <div class="filter-list">
      <div :title="item.channelName" class="filter-item" v-for="(item, index) in list" :key="index" @click="filterListClick(item)">
        <div class="name">
          <span class="item-index">
            {{ index + 1 }}
          </span>
          {{ item.channelName }}
        </div>
        <div class="count" style="margin-left: 10px;">
          {{ item.count }}
        </div>
      </div>
    </div>
    <el-dialog
      title="数据详情"
      :visible.sync="dialogVisible"
      width="72%"
      :before-close="handleClose">
      <div class="top">
          <!-- <el-table
          header-align="center"
          :data="tableData"
          style="width: 100%">
            <el-table-column
              label="父渠道"
              width="160">
              <template>
                 <el-select v-model="value" placeholder="请选择" @change="selectChange">
                  <el-option
                    v-for="item in dialogOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
             <el-table-column
            v-for="(item,index) in tablelablename"
            :key="index"
            :label="item"
            width="109">
            <span>{{tablelablevalue[index] + '1'}} </span>
            </el-table-column>
        </el-table> -->
        <table class="toptable">
          <tr >
            <th>父渠道</th>
            <th v-for="(item,index) in tablelablename"
            :key="index"
            :label="item">{{ item }}</th>
          </tr>
          <tr >
            <th class="th_border">
              <template>
                 <el-select v-model="value" placeholder="请选择" @change="selectChange" clearable>
                  <el-option
                    v-for="item in dialogOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </template>
            </th>
            <th
              v-for="(item,index) in tablelablename"
              :key="index"
              :label="item"
              class="th_border">
              <span>{{tablelablevalue[index]}} </span>
            </th>
          </tr>
        </table>
      <el-table
      v-if="tableDataList.length>0"
          header-align="center"
          :data="tableDataList"
          :show-header="false"
          height="400"
          style="width: 91%;margin-left: 125px;">
           <el-table-column
            prop="sourceName"
            width="119">
          </el-table-column>
          <el-table-column
            prop="last_day_1"
            width="119">
          </el-table-column>
          <el-table-column
            prop="last_day_2"
            width="119">
          </el-table-column>
          <el-table-column
            prop="last_day_3"
            width="119">
          </el-table-column>
          <el-table-column
            prop="last_day_4"
            width="119">
          </el-table-column>
          <el-table-column
            prop="last_day_5"
            width="119">
          </el-table-column>
          <el-table-column
            prop="last_day_6"
            width="119">
          </el-table-column>
          <el-table-column
            prop="last_day_7"
            width="119">
          </el-table-column>
          <el-table-column
            prop="last_day_total"
            width="119">
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: '用户新增前十渠道'
        },
        type: {
            type: String,
            default: 'userAdd'
        },
        showFilter: {
            type: Boolean,
            default: true
        },
        options: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            data: {},
            value: '',
            tableData: [{
                date: '2016-05-02',
                name: '王小虎',
                address: ' 1518 弄'
            }],
            dialogfrom: {
                labelType: '',
                labelName: ''
            },
            tableLoading: false,
            selectType: '',
            dialogOptions: [],
            labelStatList: [],
            tablelablename: [],
            tablelablevalue: [], //
            tableDataList: [],
            tablelablenamelist: [],
            sonselectList: [],
            tableDataListObject: {},
            dataLablevalue: [],
            dialogVisible: false,
            current: 'all',
            list: [],
            loading: false,
            apiMap: {
                'userAdd': 'getUserChannel',
                'userActive': 'getActiveChannel',
                'online': 'getOnlineChannel',
                'code': 'getCodeChannel'
            }
        }
    },
    methods: {
        selectChange(e) {
            this.value = e
            if (this.value === '无数据') {
                this.value = ''
                return
            }
            if (this.dialogfrom.labelType === 1) {
                this.dialogfrom.parent = this.value
                this.dialogfrom.sourceName = ''
            } else {
                this.dialogfrom.parent = ''
                this.dialogfrom.sourceName = this.value
            }
            // console.log(this.dialogfrom)
            this.dialogClick(this.selectType)
        },
        dialogClick(item) {
            console.log('item', item)
            let apiModule = 'getFilterdialogData'
            if (item === 1) {
                apiModule = 'getFilterdialogData'
                this.tableLoading = true
                this.dialogVisible = true
                this.selectType = parseInt(1)
            } else if (item === 2) {
                apiModule = 'getavtivelistData'
                this.tableLoading = true
                this.dialogVisible = true
                this.selectType = parseInt(2)
            } else {
                return
            }
            const data = this.dialogfrom
            this.$api.data[apiModule](data).then(res => {
                const result = res.data

                this.labelStatList = result.labelStatList
                this.tablelablename = [...this.labelStatList[0]]
                this.tablelablename[0] = '渠道类型'
                this.tablelablenamelist = result.labelStatList[0]
                this.tablelablevalue = this.labelStatList[1]
                if (this.sonselectList.length == 0) {
                    if (result.parentList.length > 0) {
                        this.sonselectList = result.parentList
                    } else if (result.sourceNameList.length > 0) {
                        this.sonselectList = result.sourceNameList
                    } else {
                        this.sonselectList = ['无数据']
                    }
                }
                this.dialogOptions = this.sonselectList.map((item) => {
                    return {
                        label: item,
                        value: item
                    }
                })
                console.log(1000, this.tableDataListObject)
                this.dataLablevalue = [
                    this.tablelablenamelist,
                    ...result.channelStatList
                ]
                // 格式化
                const data = []
                this.dataLablevalue.forEach(element => {
                    const row = {
                        'sourceName': element[0],
                        'last_day_1': element[1],
                        'last_day_2': element[2],
                        'last_day_3': element[3],
                        'last_day_4': element[4],
                        'last_day_5': element[5],
                        'last_day_6': element[6],
                        'last_day_7': element[7],
                        'last_day_total': element[8]
                    }
                    data.push(row)
                })
                this.tableDataList = data
                this.tableLoading = false
                console.log(this.tableDataList)
            })
        },
        filterListClick(item) {
            console.log(item)
            this.dialogfrom.labelName = item.channelName
            this.current = this.dialogfrom.labelName
            this.dialogfrom.labelType = item.labelType
            this.dialogClick(item.clickType)
        },
        handleClose(done) {
            this.sonselectList = []
            this.dialogfrom = {}
            this.value = ''
            this.tableLoading = false
            done()
        },
        getChannel() {
            const data = {}
            if (this.current !== 'all') {
                const cur = this.current.split('-')
                if (this.type === 'online' || this.type === 'code') {
                    data.cardId = parseInt(cur[0])
                    data.status = parseInt(cur[1])
                } else {
                    const label = cur[0]
                    const value = cur[1]
                    data.labelName = label
                    data.labelType = value
                }
            }
            if (this.type === 'online') {
                data.clickType = 3
            } else if (this.type === 'code') {
                data.clickType = 4
            } else if (this.type === 'userAdd') {
                data.clickType = 1
            } else if (this.type === 'userActive') {
                data.clickType = 2
            }
            this.loading = true
            this.$api.data[this.apiModule](data).then((res) => {
                if (res.success) {
                    this.list = res.data.map((v, i) => {
                        return {
                            id: i,
                            channelName: v.countName,
                            count: v.countNumber,
                            labelType: v.labelType,
                            clickType: data.clickType
                        }
                    }).slice(0, 10)
                }
                this.loading = false
            })
        },
        getRightListData() {
            if (this.type === 'online') {
                this.current = '2-1'
                this.data.cardId = parseInt(2)
                this.data.status = parseInt(1)
                this.data.clickType = 3
            } else if (this.type === 'code') {
                this.current = '2-3'
                this.data.cardId = parseInt(2)
                this.data.status = parseInt(3)
                this.data.clickType = 4
            } else if (this.type === 'userAdd') {
                this.data.clickType = 1
            } else if (this.type === 'userActive') {
                this.data.clickType = 2
            }
            this.loading = true
            this.$api.data[this.apiModule](this.data).then((res) => {
                if (res.success) {
                    this.list = res.data.map((v, i) => {
                        return {
                            id: i,
                            channelName: v.countName,
                            count: v.countNumber,
                            labelType: v.labelType,
                            clickType: this.data.clickType
                        }
                    }).slice(0, 10)
                }
                this.loading = false
            })
        }
    },

    computed: {
        apiModule() {
            return this.apiMap[this.type]
        }
    },
    mounted() {
        this.getRightListData()
        // this.$api.data.getavtivelistData({labelType: 1,labelName: '轻松艺考（微信小程序）'})
    }
}
</script>
<style lang="less" scoped>
.rank-filter {
  margin-top: -72px;
  padding: 0 0 0 1em;
  text-align: left;
}
.rank-title {
  font-weight: 700;
  font-size: 1.3em;
  color: #000;
}
.filter-top {
  padding-top: 1em;
}
.filter-list {
  padding-top: 1em;
}
.filter-item {
  color: #8c8a8a;
  width: 230px;
  padding: 0.2em 0;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
}
.item-index {
  margin-right: 0.5em;
}
.toptable{
  th{
    width: 200px;
    font-weight: 500;
    padding: 10px;
  }
  .th_border{
    border-bottom: 2px solid #14AAFF;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Manager/Sys/RankFilter.vue